import { memo } from 'react'

import s from './SelectIcons.module.scss'

interface ISelectIconsProps {}

export const SelectIcons = memo((props : any) => {
  return <svg
  width='12'
  height='7'
  viewBox='0 0 12 7'
  fill='none'
  xmlns='http://www.w3.org/2000/svg'
  {...props}
>
  <path
      d='M1 1L5.93492 5.22993C5.97237 5.26203 6.02763 5.26203 6.06508 5.22993L11 1'
      stroke='url(#paint0_linear_9819_43382)'
      stroke-width='2'
      stroke-linecap='round'
  />
  <defs>
      <linearGradient
          id='paint0_linear_9819_43382'
          x1='1.23148'
          y1='2.19388'
          x2='8.88661'
          y2='7.8381'
          gradientUnits='userSpaceOnUse'
      >
          <stop stop-color='#FFAC6A' />
          <stop
              offset='1'
              stop-color='#FF727E'
          />
      </linearGradient>
  </defs>
</svg>
})
